import { render, staticRenderFns } from "./UrlType.vue?vue&type=template&id=feb80038&"
import script from "./UrlType.vue?vue&type=script&lang=js&"
export * from "./UrlType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feb80038')) {
      api.createRecord('feb80038', component.options)
    } else {
      api.reload('feb80038', component.options)
    }
    module.hot.accept("./UrlType.vue?vue&type=template&id=feb80038&", function () {
      api.rerender('feb80038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/UrlType.vue"
export default component.exports